<div class="slds-brand-band slds-brand-band_large">
    <div class="center">
        <h1>ERROR CODE : {{error}}</h1>
        <h3>{{errorDiscription}}</h3>
    </div>
    <img class="fbn-img" alt="Forbidden Img" src={{img}} />
</div>
